import { useCallback } from 'react'

import { type ProspectDto } from '@api'
import { useForm } from 'react-hook-form'

import { useAddProspect } from '@/modules/prospects/hooks/use-add-prospect.ts'
import { useEditProspect } from '@/modules/prospects/hooks/use-edit-prospect.ts'

import { type ProspectFormValues, prospectFormResolver } from './validation.ts'

interface Props {
  onClose: () => void
  activeProspect?: ProspectDto
}

export const useProspectForm = ({ onClose, activeProspect }: Props) => {
  const { addProspect, isAddingProspect } = useAddProspect()
  const { editProspect, isEditingProspect } = useEditProspect()

  const form = useForm<ProspectFormValues>({
    defaultValues: {
      name: activeProspect?.name || '',
      country: activeProspect?.country || '',
      website: activeProspect?.website || '',
      onlyFansUser: activeProspect?.onlyFansUser || false,
    },
    resolver: prospectFormResolver,
  })

  const onSubmit = useCallback(
    async (values: ProspectFormValues) => {
      if (activeProspect?.id) {
        await editProspect({
          ...values,
          id: activeProspect.id,
        })
      } else {
        await addProspect(values)
      }
      onClose()
    },
    [editProspect, addProspect, activeProspect, onClose],
  )

  return {
    form,
    onSubmit,
    isLoading: isAddingProspect || isEditingProspect,
  }
}
